/* Reemplazo de los whileInView de framer-motion: añade .is-revealed una sola vez.
   data-reveal="up|fade|scale|stagger"; en stagger, los [data-reveal-item] entran con 0.06 s de desfase.
   Con reduced-motion todo queda revelado de inmediato (estado final visible). */
(() => {
  const els = document.querySelectorAll('[data-reveal]');
  const reveal = (el) => el.classList.add('is-revealed');
  if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
    els.forEach(reveal);
    return;
  }
  document.querySelectorAll('[data-reveal="stagger"]').forEach((group) => {
    group.querySelectorAll('[data-reveal-item]').forEach((item, i) => { item.style.transitionDelay = `${i * 0.06}s`; });
  });
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -80px 0px' });
  els.forEach((el) => io.observe(el));
})();

/* Fundido de fotos (.img-fade): marca data-loaded al cargar (o al fallar, para no dejarla invisible).
   Escucha en captura porque 'load' de <img> no burbujea; cubre también las que ya estaban en caché. */
(() => {
  const mark = (img) => { img.dataset.loaded = '1'; };
  const done = (e) => { if (e.target instanceof HTMLImageElement && e.target.classList.contains('img-fade')) mark(e.target); };
  document.addEventListener('load', done, true);
  document.addEventListener('error', done, true);
  document.querySelectorAll('img.img-fade').forEach((img) => { if (img.complete) mark(img); });
})();

/* Capítulo "Desde 1998": [data-enfoque] pasa de desenfocado a nítido según el scroll (de que asoma por abajo
   a que llega al 45 % de la pantalla); [data-contar] cuenta de 1 a su número la primera vez que se ve.
   Sin JS o con reduced-motion queda el estado final (texto nítido, número real del Liquid). */
(() => {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const enfoque = [...document.querySelectorAll('[data-enfoque]')];
  if (enfoque.length) {
    let raf = 0;
    const update = () => {
      raf = 0;
      enfoque.forEach((el) => {
        const p = Math.min(1, Math.max(0, (innerHeight - el.getBoundingClientRect().top) / (innerHeight * 0.55)));
        el.style.filter = p < 1 ? `blur(${(14 * (1 - p)).toFixed(2)}px)` : '';
        el.style.opacity = String(0.35 + 0.65 * p);
      });
    };
    const onScroll = () => { if (!raf) raf = requestAnimationFrame(update); };
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', onScroll);
    update();
  }
  if (!('IntersectionObserver' in window)) return;
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);
      const el = e.target, to = Number(el.dataset.contar), t0 = performance.now(), dur = 1800;
      const tick = (now) => {
        const k = Math.min(1, (now - t0) / dur);
        el.textContent = String(Math.round(1 + (to - 1) * (1 - Math.pow(1 - k, 4))));
        if (k < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    });
  }, { threshold: 0.6 });
  document.querySelectorAll('[data-contar]').forEach((el) => {
    const to = parseInt(el.textContent, 10);
    if (!(to > 1)) return;
    el.dataset.contar = String(to);
    el.textContent = '1';
    io.observe(el);
  });
})();
